import { Img } from '@/components/blocks/MaterialImage';
import { promoIconSX } from '@/components/blocks/PromotionCard/styles/PromoIconStyles';
import { Box } from '@mui/material';
import { FC } from 'react';

export const PromotionIcon: FC<{
	iconURL: string;
	title: string;
	key: string;
}> = ({ iconURL, title }) => {
	const promoType = title?.split('_').pop()?.toLocaleLowerCase() || '';
	return (
		<Box>
			<Img
				src={iconURL}
				title={title?.toLocaleLowerCase()}
				sx={promoIconSX?.[promoType] ?? { width: '48px', height: '22px' }}
				id={`featureCard_promoInco_${promoType}`}
				data-testid={`featureCard_promoInco_${promoType}`}
				className={`promo-ribbon ${promoType}`}
			/>
		</Box>
	);
};
